import { Grid2 } from "@mui/material";
import React from "react";

import { OperationalKpiCard } from "../v3";
import type { OperationalDashboardViewModel } from "../../utils/crmOperationalDashboard.aggregate";
import { Assignment, Groups, Percent, Today, WarningAmber } from "@mui/icons-material";

export type CrmDashboardKpiRowProps = {
  model: OperationalDashboardViewModel | null;
  loading: boolean;
  onNavigateLeads?: () => void;
};

export const CrmDashboardKpiRow = ({ model, loading, onNavigateLeads }: CrmDashboardKpiRowProps) => {
  const kpis = model?.kpis;

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
        <OperationalKpiCard
          title="Total leads"
          value={kpis?.totalLeads ?? 0}
          secondaryText="In your current scope"
          icon={<Groups />}
          loading={loading}
          onClick={onNavigateLeads}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
        <OperationalKpiCard
          title="Open tasks"
          value={kpis?.openTasks ?? 0}
          secondaryText="Not completed"
          icon={<Assignment />}
          loading={loading}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
        <OperationalKpiCard
          title="Due today"
          value={kpis?.dueToday ?? 0}
          secondaryText="Incomplete with due date today"
          icon={<Today />}
          loading={loading}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
        <OperationalKpiCard
          title="Overdue"
          value={kpis?.overdue ?? 0}
          secondaryText="Past due & incomplete"
          icon={<WarningAmber />}
          loading={loading}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
        <OperationalKpiCard
          title="Completion rate"
          value={kpis?.completionRateLabel ?? "—"}
          secondaryText="Done / all tasks in scope"
          icon={<Percent />}
          loading={loading}
          empty={!loading && kpis?.completionRatePercent == null}
          emptyMessage="No tasks yet"
        />
      </Grid2>
    </Grid2>
  );
};
